const map = {
	"./arrow-step-1.svg": 72283,
	"./arrow-step-2.svg": 37896,
	"./arrow-step-3.svg": 3289,
	"./circle-sketch.svg": 29488,
	"./data-collection-img.webp": 35578,
	"./empower-item-1.webp": 40962,
	"./empower-item-2.webp": 41283,
	"./empower-item-3.webp": 71232,
	"./empower-item-4.webp": 9433,
	"./ico-bars.png": 53515,
	"./ico-bulb.png": 57160,
	"./ico-chip.png": 97379,
	"./ico-flask.png": 6656,
	"./ico-lens.png": 38713,
	"./ico-mountain.png": 49344,
	"./ico-people.png": 35192,
	"./ico-wallet.png": 58962,
	"./identification-opportunities.webp": 94623,
	"./implementation.webp": 72355,
	"./market-segmentation.webp": 13318,
	"./subline-red-sketch.svg": 36556
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99873;